const ETC = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10.9411" cy="10" r="10" fill="#7DFAA2" />
    <path
      d="M11.0206 13.3954C9.60053 12.6375 7.76197 11.658 6.00002 10.7223C7.20877 12.503 8.65482 14.6257 10.0526 16.6775C10.3791 17.1568 10.7029 17.6322 11.0205 18.0985C12.6947 15.6307 14.197 13.4008 16 10.7223L11.0206 13.3954Z"
      fill="black"
    />
    <path
      d="M11.026 7.40379L6.19153 9.98351L11.0287 12.5472L15.7975 9.96467L11.026 7.40379Z"
      fill="black"
    />
    <path
      d="M10.9986 1.90155L16 9.23665L11.0205 6.5775L6.00002 9.22025L10.9986 1.90155Z"
      fill="black"
    />
  </svg>
);
export default ETC;
